import ContentBox from 'components/checkout/caap/ContentBox';
import styles from 'styles/components/checkout/caap/address/addressListMessage.scss';

const DELETED_MESSAGE_RE = /(.*)\s(has\sbeen\sdeleted\.)$/;

const AddressListMessage = componentParams => {
  const {
    addressMessage
  } = componentParams;

  if (!addressMessage) {
    return null;
  }

  return (
    <div>
      <ContentBox showOnlySmallScreen={true} isFirst={true}>
        <div className={styles.addressMessageContainer}>
          { formatAddressMessage(addressMessage) }
        </div>
      </ContentBox>
      <div className={styles.hideSmallScreen}>
        <div className={styles.addressMessageContainer}>
          { formatAddressMessage(addressMessage) }
        </div>
      </div>
    </div>
  );
};

const formatAddressMessage = (message = '') => {
  const deletedMessageMatch = message.match(DELETED_MESSAGE_RE);
  if (deletedMessageMatch && deletedMessageMatch.length === 3) {
    return (
      <div className={styles.successConfirmation}>
        <div>{deletedMessageMatch[1]}</div>
        <div>has been deleted.</div>
      </div>
    );
  } else {
    return (
      <div className={styles.successConfirmation}>
        <div>{message}</div>
      </div>
    );
  }
};

export default AddressListMessage;
